function getExpiryDate(value) {
    const expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 day expiry in milliseconds

    const expiryDate = new Date().getTime() + expiryPeriod;
    return {
      value: value,
      expiryDate: expiryDate
    };
}

function setGclid() {
    const params = location.search;
	const searchParams = new URLSearchParams(params);

	for (const [key, value] of searchParams) {
		if (key.includes('gclid')) {
            localStorage.setItem(key, JSON.stringify(getExpiryDate(value)));
		}
	}

    const gclid = JSON.parse(localStorage.getItem('gclid')) || '';

    if (new Date().getTime() > gclid?.expiryDate) {
        removeGclid();
    }
}

function removeGclid() {
    localStorage.removeItem('gclid');
}

window.addEventListener('load', setGclid);
